/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../Helpers'
import {client} from '../Client';

class UserFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {idUtente: props.idUtente}
        this.state = {
            fields: fields,
            dropdownUtentiLoading: false,
            dropdownUtentiList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboUtenti = this.comboUtenti.bind(this);

    }
    componentWillReceiveProps(nextProps){

        if (nextProps.dataDal !== this.props.dataDal || nextProps.dataAl !== this.props.dataAl){
            this.comboUtenti(nextProps.dataDal, nextProps.dataAl);
        }
        if (nextProps.idUtente !== this.state.fields.idUtente)
        {
            let fields = this.state.fields;
            fields.idUtente = nextProps.idUtente;
            this.setState({fields}, ()=>{
                if ( this.state.fields.idUtente  !== undefined){
                    this.props.onChange(
                        this.state.fields.idUtente,
                        this.getDDText(this.state.fields.idUtente, this.state.dropdownUtentiList)
                    );
                }
            });
        }
    }

    componentDidMount(){
        //this.props.onChange(this.state.fields.tipo, this.state.fields.dataDal, this.state.fields.dataAl);
        this.comboUtenti(this.props.dataDal, this.props.dataAl);
    }


    loadComboUtenti(response){
        if (response.ok)
        {
            response.json().then((data)=>{

                let items = [];
                if (this.props.itemTutti){
                    items = [{idUtente: 0, username: 'Tutti'}];
                }
                items = items.concat(data.items);
                this.setState({
                        dropdownUtentiLoading: false,
                        error: null,
                        dropdownUtentiList: arrayToCombo(items, "idUtente", "username", "idUtente", false)
                    },
                    ()=>{
                        if ( this.state.fields.idUtente !== undefined){
                            this.props.onChange(
                                this.state.fields.idUtente,
                                this.getDDText(this.state.fields.idUtente, this.state.dropdownUtentiList)
                            );
                        }
                    })
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }            else
        {
            response.json().then((errore) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownUtentiLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: errore.title, msg: errore.msg},
                    inError: true
                });
            });
        }
    }

    comboUtenti(dataDal, dataAl){
        this.setState({ dropdownUtentiLoading: true });

        if (dataDal !== undefined && dataAl !== undefined){
            client.loadUtentiAllConAttivitaList(dataDal, dataAl).then((response) => this.loadComboUtenti(response)).catch((error) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownPianoDeiContiLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });
            });
        }
        else {
            client.loadUtentiAllList().then((response) => this.loadComboUtenti(response)).catch((error) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownPianoDeiContiLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });
            });

        }
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '';
    }

    onInputChange(a1, b1) {
        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
            this.props.onChange(this.state.fields.idUtente, this.getDDText(value, b1.options));
        }
    }


    render() {
        return (
            <div className="ui form">
                <div className="inline fields">
                    <Form.Field className="inline fields" width={16}>
                        <label>Utente</label>
                        <Form.Dropdown width={16} style={{width:"100%"}} name='idUtente' disabled={this.props.abilitato === false} loading={this.state.dropdownUtentiLoading}  selection options={this.state.dropdownUtentiList} value={this.state.fields.idUtente} onChange={this.onInputChange}/>
                    </Form.Field>
                </div>
            </div>)
    }
}

UserFilter.PropTypes = {
    idUtente: PropTypes.number.isRequired,
    abilitato: PropTypes.bool.isRequired,
    itemTutti: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    dataDal: PropTypes.string,
    dataAl: PropTypes.string,
};

UserFilter.defaultProps = {
    idUtente: undefined,
    abilitato: false,
    itemTutti: true,
};
export default UserFilter;



/** WEBPACK FOOTER **
 ** ./src/components/UserFilter.js
 **/